<template>
  <div>
    <v-row>
      <v-col cols="12">
        <p class="text-2xl">
          Usuários
        </p>
        <v-card flat>
          <v-card-text class="pa-3">
            <v-row>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <v-text-field
                  v-model="filterName"
                  :append-icon="icons.mdiMagnify"
                  label="Nome"
                  hide-details
                  dense
                  outlined
                  @click:append="fetchUsers"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <v-text-field
                  v-model="filterEmail"
                  :append-icon="icons.mdiMagnify"
                  label="E-mail"
                  hide-details
                  dense
                  outlined
                  @click:append="fetchUsers"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn
              color="primary"
              class="pl-4"
              @click="fetchUsers"
            >
              Pesquisar
              <v-icon
                right
                dark
              >
                {{ icons.mdiFileEdit }}
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card
          flat
          class="mt-5"
        >
          <v-data-table
            :headers="headers"
            :items="rows"
            item-key="id"
            class="table-rounded"
            disable-sort
            dense
          >
            <template #[`item.action`]="{ item }">
              <v-btn
                color="success"
                dark
                text
                title="Editar"
                x-small
                @click="openFormToEdit(item.id)"
              >
                <v-icon>{{ icons.mdiFileEdit }}</v-icon>
              </v-btn>
              <v-btn
                color="success"
                dark
                text
                title="Tarifa"
                x-small
                @click="openFormToCreateTax(item.id)"
              >
                <v-icon>{{ icons.mdiCash }}</v-icon>
              </v-btn>
              <v-btn
                color="success"
                dark
                text
                title="Serviços"
                x-small
                @click="openUserServicesDialog(item.id)"
              >
                <v-icon>{{ icons.mdiCheckboxMarkedOutline }}</v-icon>
              </v-btn>
              <v-btn
                color="success"
                dark
                text
                title="Comissão Afiliado"
                x-small
                @click="openAffiliateCustomDialog(item.id)"
              >
                <v-icon>{{ icons.mdiPercentOutline }}</v-icon>
              </v-btn>
              <v-btn
                color="success"
                dark
                text
                title="Relatório de uso"
                x-small
                @click="openUserUsageReport(item)"
              >
                <v-icon>{{ icons.mdiChartBar }}</v-icon>
              </v-btn>
            </template>
            <template #[`item.status`]="{ item }">
              <v-chip
                class="ma-2"
                :color="item.status ? 'success' : 'error'"
                small
                label
              >
                {{ item.status ? 'Ativo' : 'Inativo' }}
              </v-chip>
            </template>
            <template #[`item.document`]="{ item }">
              {{ $cpfCnpj.toMask(item.document ? item.document : '') }}
            </template>
            <template #[`item.phone`]="{ item }">
              {{ $phone.toMask(item.phone ? item.phone : '') }}
            </template>
            <template #[`item.role`]="{ item }">
              {{ roles.find(role => role.id === item.role).text }}
            </template>
            <template #[`item.customerLevelId`]="{ item }">
              {{ resolveUserLevel(item.customerLevelId) }}
            </template>
            <template #[`item.isAffiliate`]="{ item }">
              {{ item.isAffiliate ? 'Sim' : 'Não' }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <validation-observer
      ref="formUser"
      autocomplete="off"
      tag="form"
      @keyup.enter="fetchAction"
    >
      <dialog-form
        :status="formDialogStatus"
        :is-update="formIsUpdate"
        :title="'Usuário'"
        :width="1200"
        @action="fetchAction"
        @remove="removeDialogStatus = true"
        @close="formDialogStatus = !formDialogStatus"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Nome"
              rules="required|max:100"
              vid="form.name"
            >
              <v-text-field
                v-model="form.name"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                label="Nome"
                outlined
                dense
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              :value="form.email"
              label="E-mail"
              hide-details
              disabled
              dense
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.document"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              label="CPF/CNPJ"
              hide-details
              disabled
              dense
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Telefone"
              vid="form.phone"
            >
              <v-text-field
                v-model="form.phone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                label="Telefone"
                outlined
                dense
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Status"
              rules="required"
              vid="form.status"
            >
              <v-select
                v-model="form.status"
                :error-messages="errors"
                :items="[
                  { value: true, text: 'Ativo' },
                  { value: false, text: 'Inativo' },
                ]"
                :hide-details="errors.length === 0"
                label="Status"
                outlined
                dense
                item-text="text"
                item-value="value"
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Função"
              rules="required"
              vid="form.role"
            >
              <v-select
                v-model="form.role"
                :error-messages="errors"
                :items="roles"
                :hide-details="errors.length === 0"
                label="Função"
                outlined
                item-text="text"
                item-value="id"
                dense
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Função"
              rules="required"
              vid="form.customerLevelId"
            >
              <v-select
                v-model="form.customerLevelId"
                :error-messages="errors"
                :items="userLevels"
                :hide-details="errors.length === 0"
                label="Nivel"
                outlined
                item-text="text"
                item-value="id"
                dense
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Afiliado"
              rules="required"
              vid="form.isAffiliate"
            >
              <v-select
                v-model="form.isAffiliate"
                :error-messages="errors"
                :items="isAffiliateItems"
                :hide-details="errors.length === 0"
                label="Afiliado"
                outlined
                item-text="text"
                item-value="value"
                dense
              />
            </validation-provider>
          </v-col>
        </v-row>
      </dialog-form>
    </validation-observer>

    <validation-observer
      ref="formTax"
      autocomplete="off"
      tag="form"
      @keyup.enter="fetchActionTaxUser"
    >
      <dialog-form
        :status="formDialogTaxUserStatus"
        :is-update="!!formTaxUser.id"
        :width="900"
        hide-save-btn
        hide-remove-btn
        title="Tarifa do usuário"
        @action="fetchActionTaxUser"
        @remove="removeDialogTaxUserStatus = true"
        @close="formDialogTaxUserStatus = !formDialogTaxUserStatus"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Serviço"
              rules="required"
              vid="formTaxUser.serviceId"
            >
              <v-select
                v-model="formTaxUser.serviceId"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                :items="services"
                label="Serviço"
                outlined
                dense
                item-text="name"
                item-value="id"
                @change="getServiceToEdit"
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Valor unitário (R$)"
              rules="required"
              vid="formTaxUser.unitaryValue"
            >
              <v-text-field
                ref="unitaryValue"
                v-model="formTaxUser.unitaryValue"
                v-money="{
                  precision: 4,
                }"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                label="Valor unitário (R$)"
                outlined
                dense
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-card-actions class="pa-0 ma-0">
              <v-spacer />
              <v-btn
                color="primary"
                @click="fetchActionTaxUser(formTaxUser.id)"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-card
              flat
              class="mt-5"
            >
              <v-data-table
                :headers="headersTaxes"
                :items="rowsTaxes"
                item-key="id"
                dense
                class="table-rounded"
                disable-sort
              >
                <template #[`item.action`]="{ item }">
                  <v-btn
                    color="success"
                    dark
                    text
                    title="Editar"
                    x-small
                    @click="setCustomerTaxToEdit(item)"
                  >
                    <v-icon>{{ icons.mdiFileEdit }}</v-icon>
                  </v-btn>
                  <v-btn
                    color="error"
                    text
                    small
                    fab
                    @click="fetchActionRemoveCustomerTax(item.id)"
                  >
                    <v-icon>
                      {{ icons.mdiDelete }}
                    </v-icon>
                  </v-btn>
                </template>

                <template #[`item.unitaryValue`]="{ item }">
                  {{ $money(item.unitaryValue, 4) }}
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </dialog-form>
    </validation-observer>

    <dialog-form
      :status="dialogUserServicesStatus"
      :is-update="true"
      :width="900"
      hide-remove-btn
      title="Serviços do usuário"
      @action="saveUserServices"
      @close="dialogUserServicesStatus = !dialogUserServicesStatus"
    >
      <v-row>
        <v-col cols="12">
          <v-card
            flat
            class="pa-2"
          >
            <v-card-actions class="pa-0">
              <v-btn
                text
                small
                color="primary"
                @click="toggleAllServices(true)"
              >
                Marcar todos
              </v-btn>
              <v-btn
                text
                small
                color="primary"
                @click="toggleAllServices(false)"
              >
                Desmarcar todos
              </v-btn>
            </v-card-actions>
            <v-divider class="my-3" />

            <v-row>
              <v-col
                v-for="service in servicesForUserDialog"
                :key="service.id"
                cols="12"
                md="6"
              >
                <v-checkbox
                  v-model="selectedServiceIds"
                  :value="service.id"
                  :label="service.name"
                  hide-details
                  dense
                  @change="logServiceCheckboxChange(service, $event)"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </dialog-form>

    <dialog-remove
      :status="removeDialogStatus"
      :text-to-confirm="form.name"
      @action="fetchActionRemove"
      @close="removeDialogStatus = !removeDialogStatus"
    >
    </dialog-remove>

    <affiliate-custom
      :status="dialogAffiliateCustom"
      :affiliate-id="userId"
      @close="dialogAffiliateCustom = !dialogAffiliateCustom"
    />

    <dialog-form
      :status="dialogUserUsageStatus"
      :width="1100"
      hide-save-btn
      hide-remove-btn
      title="Relatório de uso"
      @close="dialogUserUsageStatus = false"
    >
      <v-row>
        <v-col cols="12">
          <p class="text-lg mb-0">
            {{ usageUserName }}
          </p>
          <p class="text-caption mb-0">
            Campanhas canceladas ficam de fora. O saldo é o saldo atual da carteira.
          </p>
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="6"
        >
          <date
            v-model="usageStartDate"
            :type="'date'"
            outlined
            dense
            hide-details
            label="Data início"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="6"
        >
          <date
            v-model="usageEndDate"
            :type="'date'"
            outlined
            dense
            hide-details
            label="Data fim"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex align-center flex-wrap"
        >
          <v-btn
            color="primary"
            class="mr-2"
            @click="fetchUserUsage"
          >
            Pesquisar
            <v-icon right>
              {{ icons.mdiMagnify }}
            </v-icon>
          </v-btn>
          <v-btn
            color="success"
            @click="exportUserUsage"
          >
            Exportar
            <v-icon right>
              {{ icons.mdiFileDownload }}
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <template v-if="usageReport">
        <v-row class="mt-2">
          <v-col
            cols="12"
            md="4"
          >
            <v-card outlined>
              <v-card-text>
                <p class="text-caption mb-1">
                  Saldo atual
                </p>
                <h3 class="text-xl font-weight-semibold mb-0">
                  R$ {{ $money(usageReport.balance.availableLimit, 2) }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-card outlined>
              <v-card-text>
                <p class="text-caption mb-1">
                  Recargas no período
                </p>
                <h3 class="text-xl font-weight-semibold mb-0">
                  R$ {{ $money(usageReport.balance.recharges, 2) }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-card outlined>
              <v-card-text>
                <p class="text-caption mb-1">
                  Uso no período
                </p>
                <h3 class="text-xl font-weight-semibold mb-0">
                  R$ {{ $money(usageReport.balance.used, 2) }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <p class="text-subtitle-1 mt-4 mb-2">
          Por serviço
        </p>
        <v-data-table
          :headers="usageHeaders"
          :items="usageReport.byService"
          item-key="serviceId"
          dense
          disable-sort
          class="table-rounded"
          no-data-text="Nenhum uso de campanha no período."
        >
          <template #[`item.campaigns`]="{ item }">
            {{ $money(item.campaigns, 0) }}
          </template>
          <template #[`item.quantity`]="{ item }">
            {{ $money(item.quantity, 0) }}
          </template>
          <template #[`item.validQuantity`]="{ item }">
            {{ $money(item.validQuantity, 0) }}
          </template>
          <template #[`item.value`]="{ item }">
            R$ {{ $money(item.value, 2) }}
          </template>
        </v-data-table>

        <p class="text-subtitle-1 mt-4 mb-2">
          Disparo WhatsApp
        </p>
        <v-row>
          <v-col
            cols="6"
            md="3"
          >
            <p class="text-caption mb-0">
              Jobs
            </p>
            <p class="font-weight-semibold mb-0">
              {{ $money(usageReport.whatsappDispatch.jobs, 0) }}
            </p>
          </v-col>
          <v-col
            cols="6"
            md="3"
          >
            <p class="text-caption mb-0">
              Mensagens
            </p>
            <p class="font-weight-semibold mb-0">
              {{ $money(usageReport.whatsappDispatch.messages, 0) }}
            </p>
          </v-col>
          <v-col
            cols="6"
            md="3"
          >
            <p class="text-caption mb-0">
              Tarifadas
            </p>
            <p class="font-weight-semibold mb-0">
              {{ $money(usageReport.whatsappDispatch.tariffedCount, 0) }}
            </p>
          </v-col>
          <v-col
            cols="6"
            md="3"
          >
            <p class="text-caption mb-0">
              Valor
            </p>
            <p class="font-weight-semibold mb-0">
              R$ {{ $money(usageReport.whatsappDispatch.tariffedValue, 2) }}
            </p>
          </v-col>
        </v-row>
      </template>
    </dialog-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  mdiFileEdit,
  mdiMagnify,
  mdiTablePlus,
  mdiCash,
  mdiDelete,
  mdiPercentOutline,
  mdiCheckboxMarkedOutline,
  mdiChartBar,
  mdiFileDownload,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import { userLevels, isAffiliateItems } from '@/utils/enum'
import AffiliateCustom from '@/views/admin/user/affiliateComission.vue'

/** Serviços ocultos no modal "Serviços do usuário" (por enquanto) */
const USER_SERVICES_EXCLUDED_IDS = [2, 3, 4, 34]

const isServiceHiddenFromUserPermissions = service => {
  if (USER_SERVICES_EXCLUDED_IDS.includes(Number(service.id))) {
    return true
  }

  const name = (service.name || '').toLowerCase()

  return (
    name.includes('voz simples')
    || name.includes('voz interativa')
    || name.includes('higienizador')
    || name.includes('whatsapp campaign')
  )
}

export default {
  components: {
    AffiliateCustom,
  },
  setup() {
    const userId = ref(null)
    const filterName = ref(null)
    const filterEmail = ref(null)
    const formDialogStatus = ref(false)
    const formDialogTaxUserStatus = ref(false)
    const removeDialogStatus = ref(false)
    const dialogUserServicesStatus = ref(false)
    const selectedServiceIds = ref([])
    const formIsUpdate = ref(false)
    const form = ref({
      id: ref(null),
      name: ref(''),
      password: ref(''),
      email: ref(null),
      document: ref(null),
      phone: ref(null),
      status: ref(null),
      role: ref(null),
      customerLevelId: ref(null),
      isAffiliate: ref(false),
    })
    const formTaxUser = ref({
      id: null,
      userId: null,
      serviceId: null,
      unitaryValue: null,
    })

    const services = ref([])

    const resolveUserLevel = value => {
      const level = userLevels.find(level => level.id === value)

      if (level) {
        return level.text
      }

      return null
    }

    const dialogAffiliateCustom = ref(false)
    const dialogUserUsageStatus = ref(false)
    const usageReport = ref(null)
    const usageUserName = ref('')
    const usageStartDate = ref(null)
    const usageEndDate = ref(null)

    return {
      userId,
      filterName,
      filterEmail,
      form,
      formDialogStatus,
      formDialogTaxUserStatus,
      removeDialogStatus,
      dialogUserServicesStatus,
      selectedServiceIds,
      formIsUpdate,
      userLevels,
      isAffiliateItems,
      resolveUserLevel,
      icons: {
        mdiFileEdit,
        mdiMagnify,
        mdiTablePlus,
        mdiCash,
        mdiDelete,
        mdiPercentOutline,
        mdiCheckboxMarkedOutline,
        mdiChartBar,
        mdiFileDownload,
      },
      headers: [
        { text: 'Ações', value: 'action', align: 'center' },
        { text: 'ID', value: 'id' },
        { text: 'Nome', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'E-mail', value: 'email' },
        { text: 'CPF/CNPJ', value: 'document' },
        { text: 'Telefone', value: 'phone' },
        { text: 'Função', value: 'role' },
        { text: 'Nível', value: 'customerLevelId' },
        { text: 'Afiliado', value: 'isAffiliate' },
      ],
      headersTaxes: [
        { text: 'Ações', value: 'action', align: 'center' },
        { text: 'ID', value: 'id' },
        { text: 'Serviço', value: 'serviceName' },
        { text: 'Valor unitário (R$)', value: 'unitaryValue' },
      ],
      services,
      formTaxUser,
      dialogAffiliateCustom,
      dialogUserUsageStatus,
      usageReport,
      usageUserName,
      usageStartDate,
      usageEndDate,
      usageHeaders: [
        { text: 'Serviço', value: 'serviceName' },
        { text: 'Campanhas', value: 'campaigns', align: 'right' },
        { text: 'Quantidade', value: 'quantity', align: 'right' },
        { text: 'Válidos', value: 'validQuantity', align: 'right' },
        { text: 'Valor', value: 'value', align: 'right' },
      ],
    }
  },

  computed: {
    ...mapState('user', ['rows', 'roles', 'levels']),
    ...mapState('customerTaxes', {
      customerTaxesRows: 'rows',
      customerTaxRow: 'row',
    }),
    rowsTaxes() {
      return this.customerTaxesRows.map(item => {
        const service = this.services.find(i => i.id === item.serviceId)

        return {
          ...item,
          serviceName: service ? service.name : '',
        }
      })
    },

    servicesForUserDialog() {
      return (this.services || []).filter(
        service => !isServiceHiddenFromUserPermissions(service),
      )
    },
  },

  async created() {
    await this.fetchUsers()
    this.services = await this.findServices()
  },

  methods: {
    ...mapActions('services', { findServices: 'find' }),
    ...mapActions('userServices', {
      findUserServices: 'find',
      updateUserServices: 'update',
      clearUserServices: 'clearUserServices',
    }),
    ...mapActions('customerTaxes', {
      findCustomerTaxes: 'find',
      findByIdCustomerTaxes: 'findById',
      createCustomerTax: 'create',
      updateCustomerTax: 'update',
      removeCustomerTax: 'remove',
    }),
    ...mapActions('user', ['find', 'findById', 'create', 'update', 'remove']),
    ...mapActions('userUsage', {
      findUserUsage: 'find',
      downloadUserUsage: 'exportUsage',
    }),

    filterVisibleUserServiceIds(serviceIds) {
      const visibleIds = new Set(this.servicesForUserDialog.map(s => s.id))

      return serviceIds.filter(id => visibleIds.has(Number(id)))
    },

    async openFormToEdit(rowId) {
      const user = await this.findById(rowId)

      if (user) {
        await this.$refs.formUser.reset()
        this.formDialogStatus = true
        this.formIsUpdate = true
        this.form = {
          id: user.id,
          name: user.name,
          password: user.password,
          email: user.email,
          document: user.document,
          phone: user.phone,
          status: user.status,
          role: user.role,
          customerLevelId: user.customerLevelId,
          isAffiliate: user.isAffiliate,
        }
      }
    },

    async getServiceToEdit(id) {
      const customerTax = this.customerTaxesRows.find(i => i.serviceId === id)
      if (customerTax) {
        this.formTaxUser = {
          id: customerTax.id,
          serviceId: customerTax.serviceId,
          userId: this.userId,
        }
        this.setUnitaryValue(customerTax.unitaryValue)
      } else {
        this.formTaxUser = {
          serviceId: id,
          userId: this.userId,
        }
        this.setUnitaryValue('0,00')
      }
    },

    async setCustomerTaxToEdit(item) {
      await this.findByIdCustomerTaxes(item.id)

      this.formTaxUser = {
        id: this.customerTaxRow.id,
        serviceId: this.customerTaxRow.serviceId,
        userId: this.userId,
      }

      this.setUnitaryValue(this.customerTaxRow.unitaryValue)
    },

    setUnitaryValue(unitaryValue) {
      const input = this.$refs.unitaryValue.$el.querySelector('input')
      input.value = this.$money(unitaryValue, 4)
      this.formTaxUser.unitaryValue = this.$money(unitaryValue, 4)
    },

    async fetchUsers() {
      await this.find({
        name: this.filterName,
        email: this.filterEmail,
      })
    },

    async fetchAction(isUpdate) {
      const body = {
        name: this.form.name,
        password: this.form.password,
        email: this.form.email,
        document: this.form.document ? this.form.document.replace(/\D/g, '') : null,
        phone: this.form.phone ? this.form.phone.replace(/\D/g, '') : null,
        status: this.form.status,
        role: this.form.role,
        customerLevelId: this.form.customerLevelId,
        isAffiliate: this.form.isAffiliate,
      }

      if (await this.$refs.formUser.validate()) {
        if (isUpdate) await this.update(body)
        else await this.create(body)

        await this.fetchUsers()
        this.formDialogStatus = false
      }
    },

    async fetchActionRemove() {
      try {
        if (this.form.id) {
          await this.remove(this.form.id)
          await this.fetchUsers()
        }
      } finally {
        this.formDialogStatus = false
        this.removeDialogStatus = false
      }
    },

    async fetchActionRemoveCustomerTax(id) {
      await this.removeCustomerTax(id)
      this.formTaxUser = {
        serviceId: null,
        userId: this.userId,
        unitaryValue: null,
      }
      this.setUnitaryValue('0,00')
      await this.findCustomerTaxes({ userId: this.userId })
    },

    async openFormToCreateTax(rowId) {
      this.userId = rowId
      const customerUserTax = await this.findCustomerTaxes({ userId: rowId })

      await this.$refs.formTax.reset()
      this.formDialogTaxUserStatus = true

      if (customerUserTax.length) {
        this.formTaxUser = {
          id: customerUserTax[0].id,
          serviceId: customerUserTax[0].serviceId,
          userId: this.userId,
          unitaryValue: this.$money(customerUserTax[0].unitaryValue, 4),
        }
        await this.findByIdCustomerTaxes(customerUserTax[0].id)
      } else {
        this.formTaxUser = {
          serviceId: null,
          userId: this.userId,
          unitaryValue: null,
        }
      }
    },

    async fetchActionTaxUser(isUpdate) {
      if (this.formTaxUser.id) await this.findByIdCustomerTaxes(this.formTaxUser.id)
      const body = {
        id: this.formTaxUser.id,
        serviceId: this.formTaxUser.serviceId,
        userId: this.userId,
        unitaryValue: this.$strip(this.formTaxUser.unitaryValue, 2),
      }

      if (await this.$refs.formTax.validate()) {
        if (isUpdate) await this.updateCustomerTax(body)
        else await this.createCustomerTax(body)

        await this.findCustomerTaxes({ userId: this.userId })
        this.formDialogTaxUserStatus = true
      }
    },

    async openUserServicesDialog(userId) {
      this.userId = userId
      this.selectedServiceIds = []
      await this.clearUserServices()

      console.group('[admin/userServices] openUserServicesDialog')
      console.log('userId editado:', userId)

      const result = await this.findUserServices({ userId })
      const rows = result?.userServices || (Array.isArray(result) ? result : [])

      console.log('resultado find:', result)
      console.log('rows carregados:', rows)

      if (Array.isArray(rows)) {
        this.selectedServiceIds = this.filterVisibleUserServiceIds(
          rows.map(r => r.serviceId),
        )
      }

      console.log('selectedServiceIds inicial:', this.selectedServiceIds)
      console.log('serviços disponíveis no modal:', this.servicesForUserDialog.map(s => ({ id: s.id, name: s.name })))
      console.groupEnd()

      this.dialogUserServicesStatus = true
    },

    toggleAllServices(checked) {
      if (checked) {
        this.selectedServiceIds = this.servicesForUserDialog.map(s => s.id)
      } else {
        this.selectedServiceIds = []
      }

      console.log('[admin/userServices] toggleAllServices', {
        checked,
        selectedServiceIds: this.selectedServiceIds,
      })
    },

    logServiceCheckboxChange(service, checked) {
      console.log('[admin/userServices] checkbox alterado', {
        userId: this.userId,
        serviceId: service.id,
        serviceName: service.name,
        checked,
        selectedServiceIds: [...this.selectedServiceIds],
      })
    },

    async saveUserServices() {
      const serviceIds = this.filterVisibleUserServiceIds(
        [...new Set(this.selectedServiceIds.map(Number))],
      ).filter(id => Number.isFinite(id) && id > 0)

      const payload = {
        userId: Number(this.userId),
        serviceIds,
      }

      console.group('[admin/userServices] saveUserServices')
      console.log('payload enviado:', payload)
      console.log('serviços marcados:', this.selectedServiceIds.map(id => {
        const service = this.services.find(s => s.id === id)
        return { id, name: service?.name || '?' }
      }))
      console.log('serviços desmarcados:', this.services
        .filter(s => !this.selectedServiceIds.includes(s.id))
        .map(s => ({ id: s.id, name: s.name })))

      const response = await this.updateUserServices(payload)

      console.log('response update:', response)

      const verify = await this.findUserServices({ userId: this.userId })
      console.log('verificação pós-save (GET):', verify)
      console.log('serviceIds após save:', verify?.userServices?.map(r => r.serviceId))
      console.log('isConfigured após save:', verify?.isConfigured)
      console.groupEnd()

      this.dialogUserServicesStatus = false
    },

    openAffiliateCustomDialog(userId) {
      this.userId = userId
      this.dialogAffiliateCustom = true
    },

    async openUserUsageReport(item) {
      this.userId = item.id
      this.usageUserName = item.name
      this.usageReport = null
      this.usageStartDate = this.$day().startOf('month').format('DD/MM/YYYY')
      this.usageEndDate = this.$day().format('DD/MM/YYYY')
      this.dialogUserUsageStatus = true
      await this.fetchUserUsage()
    },

    async fetchUserUsage() {
      if (!this.userId) {
        return
      }

      const data = await this.findUserUsage(this.usagePeriodParams())

      if (!data || data.response || data instanceof Error) {
        this.usageReport = null
        return
      }

      this.usageReport = data
    },

    usagePeriodParams() {
      return {
        userId: this.userId,
        startDate: this.usageStartDate
          ? this.$day(this.usageStartDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : undefined,
        endDate: this.usageEndDate
          ? this.$day(this.usageEndDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : undefined,
      }
    },

    async exportUserUsage() {
      if (!this.userId) {
        return
      }

      await this.downloadUserUsage(this.usagePeriodParams())
    },
  },
}
</script>
<style lang="scss">
.theme--dark {
  .v-chip {
    background-color: #06f11ab0 !important;
  }

  .v-application .primary {
    background: #06f11ab0 !important;
    background-color: white !important;
  }
}
</style>
